import { render, staticRenderFns } from "./adventure.vue?vue&type=template&id=2202d9a2"
import script from "./adventure.vue?vue&type=script&lang=js"
export * from "./adventure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports